import HttpService from "./commons/HttpService";

const SuperUserService = {
  getNewAccounts({ startDate, endDate, app }) {
    return HttpService.get("/superUserPrivateTools/newAccounts", {
      params: { startDate, endDate, app },
    });
  },

  getSubs() {
    return HttpService.get("/superUserPrivateTools/subscribers");
  },
};

export default SuperUserService;
